import { createContext } from "react";

export type RightBarExpanded = "versions" | "search" | "none";
export type RightBarContext = {
  expanded: RightBarExpanded;
  setExpanded: (expanded: RightBarExpanded) => void;
};

export const RightBarContext = createContext<RightBarContext>(undefined!);
